import React, { useContext } from 'react';
import styled from 'styled-components';
import queryString from 'query-string';
import { Grid } from '@material-ui/core';
import { ThemeContext } from 'styled-components';

const CardRecursos = ({
  title,
  subtitle,
  link,
  className,
  onClick,
  img,
  imgRobot,
  imgResults,
  imgListchack
}) => {
  const theme = useContext(ThemeContext);

  const handleClick = () => {
    if (link == 'exams/dashboard') {
      const urlEducat = window.location.origin;
      let destino
      switch (urlEducat) {
        case (`http://localhost:3000`):
          destino = `http://localhost:3001`;
          break;

        case (`https://educat-sesi.didatti.net.br`):
          destino = `https://exams-sesi-2022.didatti.net.br`;
          break;

        case (`https://educat-sesi-avaliacao.didatti.net.br`):
          destino = `https://exams-sesi-avaliacao-2022.didatti.net.br`;
          break;

        case (`https://educat-dev-2022.didatti.net.br`):
          destino = `https://exams-dev-2022.didatti.net.br`;
          break;
      }
      const exportLink = `${destino}/exams/dashboard`;
      const pathName = `/external-application-middleware?${queryString.stringify(
        { applicationName: 'exams', path: exportLink, forceLogout: false }
      )}`;

      window.open(pathName, '_self');
    }
    else{
      window.open(link, '_self');
    }
  };

  return (
    <Grid
      item
      xs={12}
      sm={6}
      md={4}
      style={{ display: 'flex', alignItems: 'center' }}
    >
      <div
        className={className}
        onClick={() => {
          handleClick();
          onClick();
        }}
      >
        <div className="card-left">
          <div
            className="div-icon"
            style={{ backgroundColor: theme.action }}
          ></div>
          {img}
        </div>
        <div className="card-right">
          <div className="title">{title}</div>
          <div className="subtitle">{subtitle}</div>
        </div>
      </div>
    </Grid>
  );
};

export default styled(CardRecursos)`
  height: 100%;
  width: 100%;
  border-radius: 8px;
  height: 150px;
  display: flex;
  flex-direction: row;
  background-color: white;
  padding: 17px;
  transition: all 0.3s ease;
  box-shadow: 0px 4px 8px 0px #7277800d, 0px 2px 4px 0px #7277800d,
    0px 1px 0px 0px #7277800d;

  &:hover {
    background-color: #eaeaea;
    cursor: pointer;
  }

  .card-left {
    width: 26%;
    height: 100%;
    border-radius: 8px;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .div-icon {
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: white;
    width: 65px;
    height: 65px;
    border-radius: 50%;
  }

  .card-right {
    width: 74%;
    height: 100%;
    border-radius: 8px;
    display: flex;
    padding-left: 20px;
    justify-content: center;
    flex-direction: column;
  }

  .title {
    font-family: Public Sans;
    font-size: 16px;
    font-weight: 600;
    color: #262930;
  }

  .subtitle {
    font-family: Public Sans;
    font-size: 12px;
    font-weight: 500;
    color: #676a71;
  }
`;
